import { makeStyles } from "@material-ui/core";

export const useCadastroAppStyles = makeStyles((theme) => ({
  textFunc: {
    color: 'rgb(183, 183, 183)',
    margin: '20px',
    [theme.breakpoints.down("xs")]: {
      color: "rgb(183, 183, 183)",
      margin: "60px 0 0 0",
      textAlign: "justify",
    },
  },
  button: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
  }
}));
